import { useLocation } from "react-router";
import Synonyms from "./Synonyms";
import Antonyms from "./Antonyms";
import "./ListSynonyms.css";
import "bootstrap";

export default function ListSynonyms() {
  const location = useLocation();
  const data = location.state?.resultData;
  const datalist = data.meanings;
  const url = location.state?.ImageUrl;

  const allAntonyms = [];

  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  datalist.forEach((meanings) => {
    if (meanings.antonyms) {
      allAntonyms.push(...meanings.antonyms);
    }
  });
  const uniqueAntonyms = [...new Set(allAntonyms)];

  return (
    <div
      className="container-fluid py-5 d-flex justify-content-center "
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8),rgba(255,255,255,0.7)),url(${url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "90hv",
        boxShadow:
          "rgb(170, 170, 175, 0.6) -5px 4px 6px inset, rgb(0, 0, 0) 2px -1px 7px inset",
      }}
    >
      <div
        className="row px-1 d-flex justify-content-center nyms-content"
        style={{
          backgroundImage: `url(${url})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          width: "80%",
          borderRadius: "55px",
          boxShadow:
            "rgba(170, 170, 175, 0.6) 5px 7px 21px, rgb(0, 0, 0) 1px 5px 12px ",
        }}
      >
        <h1 className="word">
          <i> {capitalize(data.word)} </i>
        </h1>
        <div className="md-col d-flex synonyms">
          <p className="fw-bold"> Synonyms :</p>
          <div className="d-flex flex-wrap ">
            {datalist.map((synonyms, index) => (
              <div key={index}>
                <Synonyms data={synonyms} />
              </div>
            ))}
          </div>
        </div>
        <div className="md-col d-flex justify-content-start antonyms">
          <Antonyms data={{ antonyms: uniqueAntonyms }} />
        </div>
      </div>
    </div>
  );
}
